<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="message" slot-scope="message">
          <div>
            <div class="font-weight-bold">
              <span class="text-wrap">{{message}}</span>
            </div>
          </div>
        </template>
        <template slot="subject" slot-scope="subject">
          <div>
            <span class="text-wrap">{{subject}}</span>
          </div>
        </template>
        <template slot="schoolclass" slot-scope="schoolclass">
          <div>
            <div class="font-weight-bold">{{schoolclass ? schoolclass.name : 'All'}}</div>
          </div>
        </template>
        <template slot="section" slot-scope="section">
          <div>
            <div class="font-weight-bold">{{section ? section.name : 'All'}}</div>
          </div>
        </template>
        <template slot="target" slot-scope="target">
          <div>
            <div class="font-weight-bold">
              <span class="text-wrap">
                <a-tag v-for="(targets, index) in getTargets(target)" :key="index">
                  {{targets}}
                </a-tag>
              </span>
            </div>
          </div>
        </template>
        <template slot="messagetypes" slot-scope="messagetypes">
          <div>
            <div class="font-weight-bold">
              <span class="text-wrap">
              <a-tag v-for="(types, index) in getMessageTypes(messagetypes)" :key="index">
                {{types}}
              </a-tag>
              </span>
            </div>
          </div>
        </template>
        <template slot="recipients" slot-scope="recipients">
          <div>
            <div>
              <p class="mb-0">App:
                <span class="font-weight-bold">{{recipients.push_recipients}}</span>
              </p>
              <p class="mb-0">SMS:
                <span class="font-weight-bold">{{recipients.sms_recipients}}</span>
              </p>
              <p class="mb-0">Email:
                <span class="font-weight-bold">{{recipients.email_recipients}}</span>
              </p>
            </div>
          </div>
        </template>
        <template slot="sent_on" slot-scope="sent_on">
          <div>
            <div class="text-wrap">{{moment(sent_on).format('lll')}}</div>
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- <a href="javascript:;" class="btn btn-sm btn-light mr-2" @click="showEditModal(record)">
              <edit-section ref="editSection" @edited="handleEdited"/>
            </a> -->
            <!-- Edit -->
            <a href="javascript:;"  class="btn btn-sm btn-light btn-with-addon mr-2 "
               @click="showReportModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-pie-chart" />
              </span>
              Report
            </a>

            <a-tooltip
              placement="top"
              title="View Notice"
            >
              <a href="javascript:" class="btn btn-sm btn-info mr-2" v-if="rolesetting.viewable" @click="showViewModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-eye" />
              </span>
              </a>
            </a-tooltip>

            <a-tooltip
              placement="top"
              title="Edit Notice"
            >
              <a href="javascript:" class="btn btn-sm btn-primary mr-2" v-if="rolesetting.editable" @click="showEditModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              </a>
            </a-tooltip>

            <a href="javascript:;"  v-if="rolesetting.deletable" class="btn btn-sm btn-danger btn-with-addon"
               @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>
    <report-section ref="reportSection"/>
    <edit-notice @updateTable="handleAfteredit" />
    <view-notice @updateTable="handleAfteredit"/>
  </div>
</template>
<script>
import moment from 'moment'
import ReportSection from '@/components/notify/Forms/Report/index'
import EditNotice from '@/components/notify/Edit/index'
import ViewNotice from '@/components/notify/View/index'

const columns = [
  {
    title: 'Message',
    className: 'text-left',
    width: 300,
    dataIndex: 'message',
    scopedSlots: { customRender: 'message' },
    sorter: (a, b) => a.message.localeCompare(b.message),
  },
  {
    title: 'Subject',
    className: 'text-left text-gray-6',
    width: 130,
    dataIndex: 'subject',
    scopedSlots: { customRender: 'subject' },
    sorter: (a, b) => a.subject.localeCompare(b.subject),
  },
  {
    title: 'Class',
    className: 'text-left text-gray-6',
    width: 80,
    dataIndex: 'school_class',
    scopedSlots: { customRender: 'schoolclass' },
    sorter: (a, b) => a.class.localeCompare(b.class),
  },
  {
    title: 'Section',
    className: 'text-left text-gray-6',
    width: 80,
    dataIndex: 'section',
    scopedSlots: { customRender: 'section' },
    sorter: (a, b) => a.section.localeCompare(b.section),
  },
  {
    title: 'Targets',
    className: 'text-left text-gray-6',
    width: 80,
    // dataIndex: 'section',
    scopedSlots: { customRender: 'target' },
  },
  {
    title: 'Types',
    className: 'text-left text-gray-6',
    width: 80,
    // dataIndex: 'section',
    scopedSlots: { customRender: 'messagetypes' },
  },
  {
    title: 'Recipients',
    className: 'text-left text-gray-6',
    width: 80,
    scopedSlots: { customRender: 'recipients' },
  },
  {
    title: 'Sent on',
    className: 'text-left text-gray-6',
    width: 80,
    dataIndex: 'created_at',
    scopedSlots: { customRender: 'sent_on' },
    sorter: (a, b) => moment(a.created_at).unix() - moment(b.created_at).unix(),
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'NeoNotifyTable',
  components: {
    ReportSection,
    EditNotice,
    ViewNotice,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    showViewModal(record) {
      this.$eventBus.$emit('openViewForm', record)
    },
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    handleAfteredit() {
      this.$emit('updateTable')
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showReportModal: function(schoolNotification) {
      // this.$refs.editSection.showModal(record.id)
      this.$eventBus.$emit('openSmsDeliveryReportModal', schoolNotification.id)
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Click Yes to delete this notification',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/notifications/single/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Notification has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    getTargets(data) {
      let target = []
      if (data.student) {
        target.push('Student')
      }
      if (data.teacher) {
        target.push('Teacher')
      }
      return target
    },
    getMessageTypes(data) {
      let messageType = []
      if (data.sms) {
        messageType.push('SMS')
      }
      if (data.email) {
        messageType.push('Email')
      }
      if (data.whatsapp) {
        messageType.push('Whatsapp')
      }
      if (data.push) {
        messageType.push('App')
      }
      return messageType
    },
  },
}
</script>
